import styled from 'styled-components'
import breakpoint from 'components/breakpoint'
import config from 'config'

const Subheader = styled.img.attrs(() => ({src: `${config.url}/assets/brands/srg/logo.svg`}))`
  object-fit: contain;
  margin-bottom: 12px;
  width: 69px;

  ${breakpoint('mobile')`
    flex-basis: auto;
  `};
`

export default Subheader
